import { firebase } from '@infrastructure/firebase';

export const firebaseApp = firebase.app;
export const firebaseAuth = firebase.auth;
export const firebaseFirestore = firebase.firestore;
export const firebaseFunctions = firebase.functions;
